import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=2c68dd92&scoped=true&"
import script from "./payFail.vue?vue&type=script&lang=js&"
export * from "./payFail.vue?vue&type=script&lang=js&"
import style0 from "./payFail.vue?vue&type=style&index=0&id=2c68dd92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68dd92",
  null
  
)

export default component.exports